import { FormSectionHandler } from '../entity.handler';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, DateTimeField } from '../utils';
import { ICONS } from '../icons';
import { MEDIA_STATES, NamedMediaResponse } from './model';

interface EditorValues {
    status: string;
    asset: string;
    requester: string;
    date: string;
    created: string;
    modified: string;
    input: string;
    duration: string;
}

export class MediaDetailsSectionHandler implements FormSectionHandler<NamedMediaResponse, EditorValues> {

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    type = 'form';
    icon = ICONS.media;
    bulk = false;
    readonly = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    actions = [];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.MEDIA.DETAILS.${key}`, values);
    }

    async applyUpdate(_entity: NamedMediaResponse, _payload: any): Promise<NamedMediaResponse> {
        throw new Error('Not implemented');
    }

    async mapEntityToEditor(entity: NamedMediaResponse): Promise<EditorValues> {

        this.actions = [{ id: 'delete', name: this.translate('FIELDS.DELETE'), showAlways: true }];
    
        if (['queued', 'pending', 'uploading', 'processing', 'available'].includes(entity.status)) {
            this.actions.push({ id: 'cancel', name: this.translate('FIELDS.CANCEL'), showAlways: true });
        }
   
        if (this.admin.user.owner.type === 'system') {
            this.actions.push({ id: 'data', name: this.translate('FIELDS.DATA'), showAlways: true });
        }
        return {
            asset: entity.asset && entity.asset.name,
            requester: entity.requester && entity.requester.name,
            status: entity.status,
            date: entity.date,
            created: entity.entity.creationDate,
            modified: entity.entity.modifiedDate,
            input: entity.input,
            duration: entity.duration.toString(),
        };
    }

    async mapEditorToEntity(_entity: any, _values: EditorValues): Promise<any> {
        return {};
    }
    async getFields(entity: NamedMediaResponse): Promise<FormBuilderField[]> {

        const values = MEDIA_STATES.map(x => {
            const result = {
                key: x,
                value: this.admin.i18n.instant(`ADMIN.EDITORS.MEDIA.STATUS.${x.toUpperCase()}`),
            };
            if (entity && entity.status === 'failed' && entity.data) {
                try {
                    if (entity.data?.error?.message) {
                        result.value += ` (${entity.data.error.message})`;
                    }
                } catch {
                }
            }
            return result;
        });

        const fields: FormBuilderField[] = [
            TextField('asset', this.translate('FIELDS.ASSET'), true, 1, 255),
            TextField('requester', this.translate('FIELDS.REQUESTER'), true, 1, 255),
            TextField('input', this.translate('FIELDS.INPUT'), true, 1, 255),
            TextField('duration', this.translate('FIELDS.DURATION'), true, 1, 255),
            ComboField('status', this.translate('FIELDS.STATUS'), true, values),
            DateTimeField('date', this.translate('FIELDS.DATE'), true),
            DateTimeField('created', this.translate('FIELDS.CREATED'), true),
            DateTimeField('modified', this.translate('FIELDS.MODIFIED'), true),
        ].filter(x => x);
        return EntityUtils.prepareBulk(!entity, [], fields);
    }

    async actionTriggered(entity: NamedMediaResponse, action: string): Promise<void> {
        if (action === 'data') {
            await this.admin.modal.alert(`<pre>${JSON.stringify(entity.data, null, 2)}</pre>`, this.translate('FIELDS.DATA'));
        }
        if (action === 'cancel') {
            try {
                await this.admin.applyUpdate(api => api.media.cancelMedia(entity.id));
            } catch (err) {
                this.admin.modal.error('', err);
            }
        }
        if (action === 'delete') {
            try {
                const result = await this.admin.modal.confirm(this.translate('CONFIRM_DELETE'));
                if (result) {
                    await this.admin.applyUpdate(api => api.media.deleteMediaFile(entity.id));
                }
            } catch (err) {
                this.admin.modal.error('', err);
            }
        }
    }

}
